import React, { useEffect } from 'react'

interface Props {
  name: string
  content: string
}

const Meta = ({ name, content }:Props) => {
  useEffect(() => {
    const meta = document.createElement('meta')

    meta.name = name
    meta.content = content

    document.head.appendChild(meta)

    return function cleanup() {
      document.head.removeChild(meta)
    }
  }, [name, content])

  return <></>
}

export default Meta